_           = require('underscore')
kavrayskiy7 = require('projections/kavrayskiy-7')

Math.radians = (degrees) -> degrees * Math.PI / 180

module.exports = class Util

  constructor: ->
    @resetCaches()
    @setCenterLatLng({ lng: 13.0, lat: 52.0 })

    @canvasSize       = { width: 0, height: 0 }
    @zoomStep         = 1
    @context          = null

  # ------------------------------------------------------------
  # getter / setter

  setCanvasSize: (width, height) ->
    @canvasSize.width   = width
    @canvasSize.height  = height

  setContext: (context) ->
    @context = context

  setZoomStep: (step) ->
    @resetCaches()
    @zoomStep = parseInt(step)
    @zoomStep = 1 unless _.isNumber(@zoomStep) && !_.isNaN(@zoomStep) && @zoomStep > 0
    @zoomStep = 6 unless @zoomStep <= 6
    @zoomStep

  setCenterLatLng: (latLng) ->
    return unless latLng.lat? && latLng.lng?

    @resetCaches()
    @centerCoords = kavrayskiy7({ lon: latLng.lng, lat: latLng.lat })
    @center       = latLng

  # ------------------------------------------------------------
  # other methods

  resetCaches: ->
    @_latLngToCoordinatesCache = {}
    @_coordinatesToLatLngCache = {}

  zoomIn: ->
    @setZoomStep(@zoomStep - 1)

  zoomOut: ->
    @setZoomStep(@zoomStep + 1)

  latLngToCoordinates: (latLng) ->
    cache = (@_latLngToCoordinatesCache[latLng.lat] || {})[latLng.lng] || null
    return cache if cache?

    cache = @_latLngToKavrayskiy7Coords(latLng)
    cache = @_kavrayskiy7CoordsToCoords(cache)

    @_latLngToCoordinatesCache[latLng.lat] or= {}
    @_latLngToCoordinatesCache[latLng.lat][latLng.lng] = cache

    cache

  coordinatesToLatLng: (coords) ->
    cache = (@_coordinatesToLatLngCache[coords.x] || {})[coords.y] || null
    return cache if cache?

    cache = @_coordsToKavrayskiy7Coords(coords)
    cache = @_kavrayskiy7CoordsToLatLng(cache)

    if cache?
      @_latLngToCoordinatesCache[coords.x] or= {}
      @_latLngToCoordinatesCache[coords.x][coords.y] = cache

    cache

  changeCenterByLatLng: (latLng) ->
    @setCenterLatLng({
      lat: @center.lat + latLng.lat
      lng: @center.lng + latLng.lng
    })

  # ------------------------------------------------------------
  # private

  _getScaleRatio: ->
    switch @zoomStep
      when 1 then 8000
      when 2 then 6000
      when 3 then 3500
      when 4 then 2000
      when 5 then 1300
      when 6 then 800
      else 2000

  _latLngToKavrayskiy7Coords: (latLng) ->
    return { x: latLng.lngX, y: latLng.latY } if latLng.hasKavrayskiy7 == true

    kavrayskiy7({ lat: latLng.lat, lon: latLng.lng })

  _kavrayskiy7CoordsToCoords: (kav7Coords) ->
    {
      x: (kav7Coords.x * @_getScaleRatio()) + (@canvasSize.width / 2) - (@centerCoords.x * @_getScaleRatio())
      y: (kav7Coords.y * @_getScaleRatio()) + (@canvasSize.height / 2) - (@centerCoords.y * @_getScaleRatio())
    }

  _coordsToKavrayskiy7Coords: (coords) ->
    {
      x: (coords.x - (@canvasSize.width / 2) + (@centerCoords.x * @_getScaleRatio())) / @_getScaleRatio()
      y: (coords.y - (@canvasSize.height / 2) + (@centerCoords.y * @_getScaleRatio())) / @_getScaleRatio()
    }

  _kavrayskiy7CoordsToLatLng: (kav7Coords) ->
    try
      latLng = kavrayskiy7({ x: kav7Coords.x, y: kav7Coords.y })
    catch e
      if /(Invalid input point)/.test(e.message)
        return null
      else
        throw e

    {
      lat: latLng.lat
      lng: latLng.lon
    }


// WEBPACK FOOTER //
// ./assets/js/frontend/components/countries_map/components/map/util.coffee